export default "__VITE_ASSET__m29FTAx9__";